import { Component, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiService } from '../../services/ui.service';
import { LazyLoadEvent } from 'primeng';
import { Grid2Service } from '../mi-grid-2/grid2.service';
import { Grid2Model } from '../mi-grid-2/grid-2-model';
import { Table } from 'primeng/table';
import { AppSettings } from '../../app.settings';

@Component({
  selector: 'app-mi-grid-selection',
  templateUrl: './mi-grid-selection.component.html',
  styleUrls: ['./mi-grid-selection.component.scss'],
  providers: [Grid2Service],
})
export class MiGridSelectionComponent implements OnInit {

  subscription: Subscription;
  rowData: any[] = [];
  search = '';
  @Output() rowClickedEvent = new EventEmitter<any>();
  @Output() totalCount = new EventEmitter<any>();
  @Output() actionBtnClickedEvent = new EventEmitter<any>();
  @Output() checkboxClickedEvent = new EventEmitter<any>();
  @Output() checkboxCheckedEvent = new EventEmitter<any>();
  @Output() checkboxUncheckedEvent = new EventEmitter<any>();
  @Output() allTasksEmitterEvent = new EventEmitter<any>();
  @Output() allTaskSelectedEvent = new EventEmitter<any>();
  @Output() getGridReference: EventEmitter<any> = new EventEmitter();
  @Input() url: any = '';
  @Input() bottomSearchBar: Boolean;
  @Input() isDetailScreen: Boolean;
  @Input() bottomExportButton = false;
  @Input() actionWidth = 130;
  @Input() rowSelection = 'single';
  @Input() printUrl: any = '';
  @Input() exportUrl: any = '';
  @Input() exportCSVUrl: any = '';
  @Input() columnDefs: any[] = [];
  @Input() actionButtonsDefs: any[] = [];
  @Input() pagination: any = true;
  @Input() paginationPageSize: any = 15;
  @Input() paginationStartPage: any = 0;
  @Input() defaultSortField = '';
  @Input() divClass = '';
  @Input() placeholderValue = 'Press enter to search';
  @Input() selectionCheckbox: Boolean;
  @Input() isFilterDataCalled: boolean;
  @Input() isFilterSaveScreen = false;
  @ViewChild('dt') dt: Table;
  @ViewChild('headerCheckbox') headerCheckbox: any;
  @Input() staticGridData = [];
  queryParams: any = '';
  enableResizer = 'false';
  @Input() overlayLoadingTemplate: any = '<span class="ag-overlay-loading-center b-red">' +
    'Please wait while your rows are loading</span>';
  datasource = [];
  model: Grid2Model;
  totalRecords = 0;
  sortF = '';
  first: any = 0;
  sortO = '';
  offset = 0;
  setRowLength = 10;
  searchText = '';
  selectedRecords: any = [];
  preSelectedTasks = [];
  allTask = [];
  currentObj;
  showConfirmationPopup = false;
  headerConfirmation = false;
  isPreselected = false;
  constructor(private elm: ElementRef, private uiService: UiService, private gridService: Grid2Service) { }

  ngOnInit() {
    this.subscription = this.uiService.sidebarToggledEvent
      .subscribe((state: string) => {
        this.refreshList();
      });
  }

  ngDoCheck(): void {
  }

  onResize(event: any) {
    // this.refreshList();
  }

  refreshList() {
    this.fetchAndLoadData();
  }

  fetchAndLoadData() {
    this.selectedRecords = [];


    const that = this;
    this.gridService.loadGridData(that.getUrl(that.url)).subscribe(result => {
      this.allTask = [];
      this.preSelectedTasks = [];

      const model = <Grid2Model>result;
      if (result !== undefined) {
        this.totalRecords = model.count;
        that.datasource = [];

        if (this.staticGridData.length > 0) {
          model.data = this.staticGridData;

        }
        this.isPreselected = this.updateHeaderCheckbox(model.data);

        model.data.forEach(e => {
          that.columnDefs.forEach(c => {
            if (c && c.cellRenderer) {
              e[c.field] = c.cellRenderer(e[c.field]);
            } else if (c && c.cellRendererHtml) {
              e[c.field] = c.cellRendererHtml(e);
            }

            // that.actionButtonsDefs.forEach(d => {
            //   if (d.show) {
            //     e[d.field] = d.show(e);
            //   }
            // });

            that.actionButtonsDefs.forEach(d => {
              if (d.show) {
                e[d.field] = d.show(e);
              }
              if (d.title) {
                e[d.title] = d.title(e);
              }
            });
          });
          that.datasource.push(e);
          this.allTask.push(e);
          if (e.status === 50) {
            this.selectedRecords.push(e);
            this.preSelectedTasks.push(e.id);
          }
        });
        this.allTasksEmitterEvent.emit(this.allTask);
        this.checkboxClickedEvent.emit(this.selectedRecords);
      }
      this.totalCount.emit(this.totalRecords);
      this.dt.first = this.offset;
    });
  }

  updateHeaderCheckbox(data) {
    const parentArray = data;
    let count = 0;
    parentArray.forEach(element => {
      if (element.status === 50) {
        count++;
      } else {
        count;
      }
    });
    return count === parentArray.length;
  }

  getUrl(url) {
    const that = this;
    let params = 'searchText=' + this.searchText + '&offset=' + this.offset + '&limit=' + this.setRowLength;
    params += '&sortColumn=';
    params += this.sortF;
    params += '&sortType=';
    params += this.sortO;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }
    buildUrl += params;
    return buildUrl;
  }

  public onQuickFilterChanged($event, dt) {
    if ($event.key === 'Enter') {
      this.applySearch(this.search);
      dt.first = 0;
    }
  }

  keyPress($event) {
    const invalidKeys = AppSettings.NOT_ALLOWED_KEYS;
    if (invalidKeys.indexOf($event.key) !== -1) {
      return false;
    }
  }

  updateUrl(url: string) {
    this.url = url;
    this.offset = 0;
    this.first = 0;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    } else {
      this.queryParams = '';
    }
    this.refreshList();
  }

  updateData(url: string) {
    this.url = url;
    const paramArray: any[] = this.url.split('?');
    if (paramArray.length > 1) {
      this.queryParams = paramArray[1];
    } else {
      this.queryParams = '';
    }
    this.refreshList();
  }

  loadDatasourceLazy(event: LazyLoadEvent) {
    if (!this.isFilterSaveScreen || this.isFilterDataCalled) {
      this.sortF = this.defaultSortField;
      this.offset = event.first;
      this.first = event.first;
      this.setRowLength = event.rows;
      if (event.sortField !== undefined) {
        this.sortF = event.sortField;
      }
      this.sortO = event.sortOrder > 0 ? 'asc' : 'desc';
      this.fetchAndLoadData();
    }
  }

  onRowSelect(event) {
    this.checkboxCheckedEvent.emit(event.data.id);
    this.rowClickedEvent.emit(event);
    this.checkboxClickedEvent.emit(this.selectedRecords);
  }



  onRowUnselect(event) {
    this.currentObj = event.data;
    this.checkboxUncheckedEvent.emit(event.data.id);
    this.checkboxClickedEvent.emit(this.selectedRecords);
    if (this.preSelectedTasks.includes(event.data.id)) {
      this.showConfirmationPopup = true;
    } else {
      this.showConfirmationPopup = false;
    }

  }

  confirmationYes() {
    this.showConfirmationPopup = false;
    this.checkboxUncheckedEvent.emit(this.currentObj.id);
    this.checkboxClickedEvent.emit(this.selectedRecords);
    // this.dt.value = [];
  }

  confirmationNo() {
    this.headerCheckbox.checked = true;
    this.showConfirmationPopup = false;
    this.selectedRecords = [...this.selectedRecords, this.currentObj];
    // this.allTask = this.selectedRecords;
    // this.allTasksEmitterEvent.emit(this.allTask);
    this.checkboxClickedEvent.emit(this.selectedRecords);
    // this.refreshList();
  }



  CheckforCompleted() {
    if (this.headerCheckbox.checked === false && this.isPreselected) {
      this.headerConfirmation = true;
    }
    if (this.headerCheckbox.checked === true) {
      this.allTaskSelectedEvent.emit(true);
    } else if (this.headerCheckbox.checked === false) {
      this.allTaskSelectedEvent.emit(false);
    }
  }

  yesHeaderConfirmation() {
    this.allTasksEmitterEvent.emit(this.allTask);
    this.allTaskSelectedEvent.emit(false);
    this.checkboxClickedEvent.emit(this.selectedRecords);
    this.headerConfirmation = false;
  }

  noHeaderConfirmation() {
    this.headerCheckbox.checked = true;

    this.selectedRecords = this.allTask;
    this.allTasksEmitterEvent.emit(this.allTask);
    this.checkboxClickedEvent.emit(this.selectedRecords);
    this.headerConfirmation = false;
  }


  actionBtnClick(event, data: any, action: string) {
    event.stopPropagation();
    const obj = { row: data, class: action };
    this.actionBtnClickedEvent.emit(obj);
  }

  checkboxClick(event, data: any) {
    // this.checkboxClickedEvent.emit(this.selectedRecords);
  }

  onCheckboxChange(data) {
    // console.log(data);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSelectedRecords() {
    return this.selectedRecords;
  }

  applySearch(searchText: string) {
    this.searchText = searchText;
    this.offset = 0;
    this.first = 0;
    this.fetchAndLoadData();
  }

  exportGridExcel(event: any) {
    const that = this;
    this.gridService.downloadExcelGridData(that.getUrl(that.exportUrl + '?' + this.searchText + '&' + this.queryParams));
  }

  exportGridPdf(event: any) {
    const that = this;
    this.gridService.downloadPdfGridData(that.getUrl(that.printUrl + '?' + this.searchText + '&' + this.queryParams));
  }

  getTitle(value) {
    return value.replace('<br>', ', ');
  }

}
